var n=function(n,i){return n[Object.keys(n).find((function(o){var r,t;return(null===(t=null===(r=n[o])||void 0===r?void 0:r.option)||void 0===t?void 0:t.alias)===i}))||""]};export{n as getOptionByAlias};
//# sourceMappingURL=getOptionByAlias.js.map
